// extracted by mini-css-extract-plugin
export default {"BaseImage_loading":"BaseImage_BaseImage_loading__jbWhx","gradient":"BaseImage_gradient__Av9cC","BaseImage_hide":"BaseImage_BaseImage_hide__k9non"};